import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_AI_LOCAL_API_REQUESTS } from './constants';

/** GET /admin/ai/usage?yearMonth=YYYY-MM — system admin only. */
export const getAdminAiUsage = async (yearMonth) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `admin/ai/usage?yearMonth=${encodeURIComponent(yearMonth)}`,
    isLocalApiRequest: ADMIN_AI_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
